export default function isListEmpty(list) {
  if (!list) {
    return true;
  }
  return list.length === 0;
}
